
import React from "react";
import { Container, Stack, IconButton, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CallIcon from '@mui/icons-material/Call';

const Footer = () => {
  return (
    <footer>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "50px",
        }}
      >

        <Stack spacing={2} direction="row">
          <IconButton
            color="primary"
            href="mailto:ravulapallisireesha.official@gmail.com"
            title="Email"
          >
            <EmailIcon />
          </IconButton>
          <IconButton
            color="primary"
            href="tel:+91 9182311205"
            title="Tellphone"
          >
            <CallIcon />
          </IconButton>
          <IconButton
            color="primary"
            href="https://github.com/rsiree"
            title="GitHub"
            target="_blank"
          >
            <GitHubIcon />
          </IconButton>
          <IconButton
            color="primary"
            href="https://www.linkedin.com/in/sireesha-ravulapalli-64b180228/"
            title="LinkedIn"
            target="_blank"
          >
            <LinkedInIcon />
          </IconButton>
        </Stack>

        <Typography
          sx={{
            padding: "1rem",
            textAlign: "center",
            fontSize: { xs: "0.9rem", md: "1.10rem" },
          }}
        >
          <IconButton
            color="primary"
          >
            <CallIcon />
          </IconButton>
          <span>+91 9182311205</span> 
          <br></br>
          <IconButton
            color="primary"
          >
            <EmailIcon />
          </IconButton>
          <span>ravulapallisireesha.official@gmail.com</span>

        </Typography>
       
      </Container>
    </footer>
  );
};

export default Footer;